/*
single-tips.js
    tip detail page support
    - vote counts
 */

const id = $('.js-post-block').data('id');
let vote = $.cookie(`tip_helpful_vote_${id}`);
// console.log('cookie vote: ',vote);
const $nothelpfulPopup = $('.js-article-not-helpful-popup');

const $upVote = $('.js-up-vote').on('click', () => {
    $upVote.removeClass('active');
    // eslint-disable-next-line no-use-before-define
    $downVote.removeClass('active');

    let clear;
    if (vote === 'yes') {
        // clear vote
        clear = true;
        vote = null;
    } else {
        $upVote.addClass('active');
        vote = 'yes';
    }
    $.ajax({
        url: '/wp-json/clorox/v1/tips/upvote',
        method: 'POST',
        data: {
            id,
            clear,
        },
    });
});
const $downVote = $('.js-down-vote').on('click', () => {
    $upVote.removeClass('active');
    $downVote.removeClass('active');

    let clear;
    if (vote === 'no') {
        clear = true;
        vote = null;
    } else {
        $downVote.addClass('active');
        vote = 'no';
    }
    $.ajax({
        url: '/wp-json/clorox/v1/tips/downvote',
        method: 'POST',
        data: {
            id,
            clear,
        },
    });

    if (vote === 'no') {
        // show not helpful popup
        $nothelpfulPopup.modal('show');
    }
});

// set initial state
if (vote && !$.isEmptyObject(vote)) {
    if (vote === 'yes') {
        $upVote.addClass('active');
    } else {
        $downVote.addClass('active');
    }
}

// lazy loader
$('.lazy-product-tile').Lazy();

// popup handlers
$('.js-goto-howto').on('click', () => {
    window.location = translatedStrings.urls['/how-to/'];
});
